export { WherdProvider } from "./WherdProvider";
export type { WherdProviderProps } from "./WherdProvider";
export { MessagesWidget, MessagesFAB } from "./components/MessagesWidget";
export type { FabPosition } from "./components/MessagesWidget";
export { FeatureBoard } from "./components/FeatureBoard";
export { WhatsNew } from "./components/WhatsNew";
export { rnStorage, rnDevice, rnShake, rnEventSource } from "./adapters";

// Re-export the headless API so consumers build custom UIs from one import.
export {
  useWherd,
  useWherdState,
  useComposer,
  useMessages,
  useUnreadMessages,
  useAnnouncements,
  useFeatureRequests,
  useChangelog,
  useUnreadChangelog,
  useResolvedTheme,
  type WherdUser,
  type WherdView,
  type MessageThread,
  type MessageReply,
  type MessageType,
  type Announcement,
  type FeatureRequest,
  type ChangelogEntry,
  type ThemeTokens,
  type ResolvedTheme,
  type WidgetConfig,
} from "@wherdkit/core";
